import { useEffect, useState } from "react";

function FAQ() {

  const [faqs, setFaqs] = useState([]);
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");

  /* ---------- FETCH FAQ FROM DATABASE ---------- */

  useEffect(() => {

    fetch("https://api.washim.org/api/faq")

      .then(res => res.json())

      .then(data => setFaqs(data))

      .catch(err => console.log(err));

  }, []);

  /* ---------- ASK CUSTOM QUESTION ---------- */

  const askQuestion = async (e) => {

    e.preventDefault();

    const res = await fetch(
      "https://api.washim.org/api/faq/ask",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ question })
      }
    );

    const data = await res.json();

    setAnswer(data.answer);

  };

  /* ---------- SELECT FAQ QUESTION ---------- */

  const selectFAQ = (faq) => {

    setQuestion(faq.question);

    setAnswer(faq.answer);

  };

  return (

    <div className="container mt-5 mb-5">



      <div className="row">

        {/* ---------- FAQ QUESTION LIST ---------- */}

        <div className="col-md-5">

          <div className="card shadow">

            <div className="card-header fw-bold text-center">

              Frequently Asked Questions

            </div>

            <div
              className="card-body"
              style={{
                maxHeight: "350px",
                overflowY: "auto"
              }}
            >

              {faqs.length === 0 ? (

                <p className="text-muted text-center">
                  No questions available
                </p>

              ) : (

                faqs.map((faq, index) => (

                  <div
                    key={index}
                    className="border rounded p-2 mb-2"
                    style={{
                      cursor: "pointer",
                      background: "#fff8e1"
                    }}
                    onClick={() => selectFAQ(faq)}
                  >

                    ❓ {faq.question}

                  </div>

                ))

              )}

            </div>

          </div>

        </div>


        {/* ---------- ANSWER SECTION ---------- */}

        <div className="col-md-7">

          <div className="card shadow p-4">

            <h5 className="mb-3">

              Selected Question

            </h5>

            <textarea
              className="form-control mb-3"
              rows="3"
              placeholder="Ask about temple timings, pooja, parking, prasadi..."
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
            />

            <button
              className="custom-link-btn mb-3"
              onClick={askQuestion}
            >

              Ask Question

            </button>

            {answer && (

              <div
                className="alert alert-success"
                style={{
                  maxHeight: "250px",
                  overflowY: "auto"
                }}
              >

                <strong>Answer:</strong>
                <p className="mt-2 mb-0">
                  {answer}
                </p>

              </div>

            )}

          </div>

        </div>

      </div>

    </div>

  );

}

export default FAQ;